import { gql } from '@apollo/client';

export const getActivePersonsQuery = gql`
  query getActivePersonsQuery(
    $pagination: PaginationInput!
    $keywordSearch: String
  ) {
    SalesforceManagement {
      queries {
        getPersonList(
          pagination: $pagination
          OrderBy: {
            Attribute: "SalesforceManagement_Person_FullName"
            Descending: false
          }
          SelectedStatuses: ACTIVE
          KeywordSearch: $keywordSearch
        ) {
          paging {
            pageSize
            pageNumber
            totalCount
          }
          items {
            salesforceManagement_Person_Id
            salesforceManagement_Person_FullName
            salesforceManagement_Person_PersonCode
          }
        }
      }
    }
  }
`;

export const getBusinessUserLovs = gql`
  query getBusinessUserLovs {
    SalesforceManagement_BusinessUserStatuses: __type(
      name: "SalesforceManagement_BusinessUserStatuses"
    ) {
      name
      enumValues {
        name
      }
    }
    SalesforceManagement {
      lookups {
        businessUserTypes {
          Code
          Title
          Id
        }
        businessUserAccesses {
          Code
          Title
          Id
        }
      }
    }
  }
`;

export const createBusinessUser = gql`
  mutation createBusinessUser(
    $businessUserInputs: SalesforceManagement_BusinessUserInputs!
  ) {
    salesforceManagement {
      actions {
        createBusinessUser(businessUserInputs: $businessUserInputs) {
          id
        }
      }
    }
  }
`;

export const updateBusinessUser = gql`
  mutation updateBusinessUser(
    $entityId: String!
    $personID: String!
    $type: String!
    $access: String!
    $account: String
    $isAdmin: Boolean
  ) {
    salesforceManagement {
      entities {
        businessUser {
          salesforceManagement {
            updateBusinessUser(
              entityId: $entityId
              personID: $personID
              type: $type
              access: $access
              account: $account
              isAdmin: $isAdmin
            ) {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Account
                    Type {
                      Code
                      Title
                    }
                    Access {
                      Code
                      Title
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const checkBusinessUserByPerson = gql`
  query checkBusinessUserByPerson($selectedPersonID: String!) {
    SalesforceManagement {
      queries {
        checkBusinessUserByPerson(selectedPersonID: $selectedPersonID) {
          salesforceManagement_BusinessUser_Id
          salesforceManagement_BusinessUser_PersonID {
            id
            views {
              SalesforceManagement_all {
                properties {
                  FullName
                  PersonCode
                }
              }
            }
          }
          salesforceManagement_BusinessUser_Status
        }
      }
    }
  }
`;

export const getPersonEmailDetailsInfo = gql`
  query getPersonEmailDetailsInfo($id: String!) {
    SalesforceManagement {
      entities {
        person(id: $id) {
          views {
            SalesforceManagement_all {
              properties {
                Email
              }
            }
          }
        }
      }
    }
  }
`;
